import { render } from "./ModalCancelarReserva.vue?vue&type=template&id=cb5f1350&scoped=true"
import script from "./ModalCancelarReserva.vue?vue&type=script&lang=js"
export * from "./ModalCancelarReserva.vue?vue&type=script&lang=js"

import "./ModalCancelarReserva.vue?vue&type=style&index=0&id=cb5f1350&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5f1350"]])

export default __exports__